import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DashboardService} from './api/dashboard.service';
import {DashboardConfigurationModel} from './api/dashboard-configuration-model';
import {ActivatedRoute, Router} from '@angular/router';
import { createSpinner } from '@syncfusion/ej2-popups';
import {UserInfoService} from './api/user-info.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Portal';
  dashboards: DashboardConfigurationModel[];
  private hideUI = true;

  constructor(private dashboardService: DashboardService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private userInfoService: UserInfoService) { }

  async ngOnInit() {
    this.initPings();
    this.initSessionExtension();

    this.activatedRoute.queryParams.subscribe((params: {hideUI: boolean}) => {
      this.hideUI = params.hideUI || false;
      console.log(this.hideUI, params);
    });

    try
    {
      const dashboardList = await this.dashboardService.getList().toPromise();
      this.dashboards = dashboardList.filter(d => d.visible);
    } catch(e) {
      alert('Try ro refresh the page: ' + e.error.message);
      console.error(e);
    }

    return ;

    if (this.dashboards.length > 0) {
      await this.router.navigate(['dashboard', this.dashboards[0].dashboardName]);
    }
  }

  ngAfterViewInit() {
    // createSpinner() method is used to create spinner
    createSpinner({
      // Specify the target for the spinner to show
      target: document.getElementById('wrapper')
    });
  }

  private initPings() {
    setInterval(() => {
      this.userInfoService.ping().then(() => console.log('ping'));
    }, 5000);
  }

  private initSessionExtension() {
    let lastActivityTime = new Date();

    $(() => {
        $('*').bind('mousemove click mouseup mousedown keydown keypress keyup submit change mouseenter scroll resize dblclick', () => {
        lastActivityTime = new Date();
      });
    });

    setInterval(() => {
      const now = new Date();
      const diff = now.getTime() - lastActivityTime.getTime();
      const mins = Math.floor(diff / (1000 * 60));

      if (mins > 1) {
        return;
      }

      this.userInfoService.extendSession().then(() => console.log('extendSession'));
    }, 10000);
  }
}
